import { Directive, Input, EventEmitter, Output, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[citoDoeScrollSpy]',
  standalone: true
})
export class ScrollSpyDirective {
  @Input() public spiedTags: string[] = [];
  @Output() public sectionChange = new EventEmitter<string>();
  private currentSection!: string;

  constructor(private _el: ElementRef) {}

  @HostListener('scroll', ['$event'])
  onScroll(event: Event) {
    const children = this._el.nativeElement.children;
    const scrollTop = (event.target as HTMLElement).scrollTop;
    const parentOffset = (event.target as HTMLElement).offsetTop;
    const margin = 1;
    
    for (let i = 0; i < children.length; i++) {
      const element = children[i];
      if (this.spiedTags.some(spiedTag => spiedTag === element.tagName)) {
        if ((element.offsetTop - parentOffset) <= (scrollTop + margin) && 
            (scrollTop + (event.target as HTMLElement).clientHeight) > (element.offsetTop + margin)) {
          this.currentSection = element.id;
        }
      }
    }
    this.sectionChange.emit(this.currentSection);
  }
}
